import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LoadingService } from './loading.service';

@Injectable({
  providedIn: 'root'
})
export class RestService {

  constructor(private http: HttpClient, private loadingService: LoadingService) { }

  async get(url: string, msg?: string) {
    let _id: any = msg ? this.loadingService.add(msg) : null;
    try {
      let res = await this.http.get(encodeURI(url)).toPromise();
      this.loadingService.remove(_id);
      return res;
    }
    catch (e: any) {
      console.log('REST ERROR', e.message);
      this.loadingService.remove(_id);
      return { err: e.message }
    }
  }
}
